import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
// import registerServiceWorker from './registerServiceWorker';
import * as registerServiceWorker from "./registerServiceWorker";
import configureStore from "./redux/store";
import AppWithLoader from "./AppWithLoader";

const { persistor, store } = configureStore();
if (window.location.search) {
  const query = new URLSearchParams(window.location.search);
  if (query.has("push-token")) {
    localStorage.setItem("staff-app-push-token", query.get("push-token"));
  }
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppWithLoader />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
// registerServiceWorker.register();
registerServiceWorker.register({
  onUpdate: async registration => {
    // We want to run this code only if we detect a new service worker is
    // waiting to be activated.
    // Details about it: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
    if (registration && registration.waiting) {
      await registration.unregister();
      // Once the service worker is unregistered, we can reload the page to let
      // the browser download a fresh copy of our app (invalidating the cache)
      window.location.reload();
    }
  }
});
